// extracted by mini-css-extract-plugin
export var logo = "_52-2";
export var logoWrapper = "_52-1";
export var strip = "_52-0";